import assign from 'lodash/assign';
import { ModalState, ModalActions, ModalActionTypes } from '~/types/modal';
import { ReduxState } from '~/types/redux';

const initialState: ModalState = {
  activeModal: null,
  modalProduct: undefined,
  modalPriceProduct: undefined,
  modalData: undefined,
};

const modal = (state: ReduxState, action: ModalActions): ReduxState => {
  switch (action.type) {
    case ModalActionTypes.SET_ACTIVE_MODAL:
      return assign({}, state, {
        modal: assign({}, state.modal || initialState, { activeModal: action.modalKey }),
      });

    case ModalActionTypes.SET_MODAL_PRODUCT:
      return assign({}, state, {
        modal: assign({}, state.modal || initialState, {
          modalProduct: action.product,
        }),
      });

    case ModalActionTypes.SET_MODAL_PRICE_PRODUCT:
      return assign({}, state, {
        modal: assign({}, state.modal || initialState, {
          modalPriceProduct: action.priceProduct,
        }),
      });

    case ModalActionTypes.SET_MODAL_DATA:
      return assign({}, state, {
        modal: assign({}, state.modal || initialState, {
          modalData: action.data,
        }),
      });

    case ModalActionTypes.CLEAR_MODAL:
      return assign({}, state, {
        modal: assign({}, state.modal || initialState, {
          activeModal: null,
          modalProduct: undefined,
          modalData: undefined,
        }),
      });

    default:
      return state;
  }
};

export default modal;
